import GroupStatusEnum from "./enums/GroupStatusEnum";
import { ILocationByCluster } from "./types/ILocationByCluster";
import ISelectItem from "./types/ISelectItem";
import { ICustomer } from "./types/ICustomer";
const calcgroupStatusState = (clusterItems: ISelectItem[]): GroupStatusEnum => {
    let foundSelected = false;
    let foundNotSelected = false;
    for (const item of clusterItems) {
        if(item.selected){
            foundSelected = true;
        }else{
            foundNotSelected = true;
        }
        if(foundSelected && foundNotSelected){
            return GroupStatusEnum.Mixed;
        }
    }
    if(foundSelected){
        return GroupStatusEnum.AllSelected;
    }else{
        return GroupStatusEnum.NoneSelected;
    }
}

const flatClusterLocations = (locationByClusters: ILocationByCluster[], selectedLocationIds: string[]): ISelectItem[] => {
    const selectItems: ISelectItem[] = [];
    for (const cluster of locationByClusters) {
        if(!cluster.customerLocations || cluster.customerLocations.length === 0) continue;
        const listElements = cluster.customerLocations.map(location => {return {
            isGroup: false,
            text: location.name,
            value: location.locationId,
            selected: selectedLocationIds.includes(location.locationId),
            disabled: null,
            groupStatus: null,
            groupId: location.clusterId,
            isPatientTransport: location.isPatientTransport
        }});
        const groupItem: ISelectItem = {
            isGroup: true,
            text: cluster.clusterName,
            value: listElements[0].groupId,
            selected: null,
            disabled: null,
            groupStatus: calcgroupStatusState(listElements),
            groupId: null,
        };
        selectItems.push(groupItem);

        selectItems.push(...listElements);
    }
    return selectItems;
}
const flatCustomers = (customer: ICustomer[], selectedcustomerIds: string[]): ISelectItem[] => {
    const selectItems: ISelectItem[] = [];
    const listElements = customer.map(customers => {return {
        isGroup: false,
        text: customers.name,
        value: customers.customerId,
        selected: selectedcustomerIds.includes(customers.customerId),
        disabled: null,
        groupStatus: null,
        groupId: null,
        isPatientTransport: null
    }});
    selectItems.push(...listElements);
    return selectItems;
}
export {
    calcgroupStatusState,
    flatClusterLocations,
    flatCustomers
};